import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

export function AddItemButton(handleOpenAddItemSampleRequestModal) {
  return (
    <Grid item>
      <Button
        size="small"
        variant="contained"
        sx={{
          padding: "10px 20px",
          mr: "20px",
          fontSize: "14px",
          backgroundColor: "#c7ab79",
          textTransform: "capitalize",
        }}
        onClick={() => handleOpenAddItemSampleRequestModal()}
      >
        Add Item
      </Button>
    </Grid>
  );
}
